<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <a @click.prevent="handleBack('/new-game')" class="btn btn--icon btn--white"><i class="material-icons">keyboard_arrow_left</i></a>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Tournaments</h1>
                    </div>
                </div>
            </div>
        </header>

        <div class="bg--layer-dark pt--md pb--20 mb--lg" v-if="featuredTournaments">
            <h2 class="title-primary text--center"><span class="c--gradient-primary">Featured</span></h2>

            <div class="swiper-container tournament-carousel">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="tournament in featuredTournaments">
                        <router-link :to="'/tournament/' + tournament.id" class="tournament-box" :style="'background-image: url(' + tournament.image + ');'">
                            <img class="tournament-box__bg" :src="tournament.image" alt="" />

                            <div v-if="! tournament.entry_fee" class="tournament-box__tags">Free to enter</div>

                            <div class="tournament-box__content">
                                <h4 class="tournament-box__title">{{ tournament.name }}</h4>
                                <time :datetime="tournament.start_date">{{ tournament.start_date }} (CET)</time>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row mb--md">
                <div class="col-6">
                    <select class="form-control" v-model="level">
                        <option value="all">All levels</option>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                        <option value="4">Level 4</option>
                    </select>
                </div>

                <div class="col-6">
                    <select class="form-control" v-model="capacity">
                        <option value="all">All capacities</option>
                        <option value="2">2</option>
                        <option value="4">4</option>
                        <option value="8">8</option>
                        <option value="16">16</option>
                        <option value="32">32</option>
                        <option value="64">64</option>
                        <option value="128">128</option>
                        <option value="256">256</option>
                        <option value="512">512</option>
                    </select>
                </div>
            </div>

            <div class="panel bg--layer-light profile profile--horizontal mb--md" v-for="tournament in filteredTournaments">
                <div class="profile__text" @click="showTournamentPage(tournament)">
                    <div class="profile__name">{{ tournament.name }}</div>

                    <div class="profile__text__info">
                        <div>
                            <span class="badge badge--primary">Level {{ tournament.minimum_level }}+</span>
                            <span>{{ tournament.start_date }}</span>
                        </div>

                        <div>
                            <img src="/img/icons/user-orange.svg" alt="" />
                            <span>{{ tournament.registered_users_number }} / {{ tournament.number_of_participants }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <navigation></navigation>
    </div>
</template>

<script>
import Navigation from "../partial/Navigation";
import api from "../../api/tournaments";
import internalBackRoute from "../../mixins/internalBackRoute";
import Swiper from "swiper";

export default {
name: "TournamentList",
    components: {Navigation},
    mixins: [internalBackRoute],

    data: function () {
        return {
            tournaments: null,
            level: 'all',
            capacity: 'all',
            swiper: null,
        }
    },

    computed: {
        featuredTournaments() {
            return collect(this.tournaments).filter((tournament) => tournament.featured)
        },

        filteredTournaments() {
            return collect(this.tournaments)
                .when(this.level !== 'all', (tournaments) => tournaments.filter((tournament) => tournament.minimum_level <= parseInt(this.level)))
                .when(this.capacity !== 'all', (tournaments) => tournaments.filter((tournament) => tournament.number_of_participants == this.capacity))
        }
    },

    methods: {
        async loadTournaments() {
            try {
                let response = await api.tournaments()

                this.tournaments = response.data.data
            } catch (e) {

            }
        },

        showTournamentPage(tournament) {
            this.$router.push('/tournament/' + tournament.id)
        }
    },

    created() {
        this.loadTournaments()

        if (!this.swiper) {
            this.$nextTick(function () {
                this.swiper = new Swiper('.tournament-carousel', {
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                });
            })
        }
    }
}
</script>
